import * as ItemApi from '../api/ItemManipulation'

export const submitItem = (formData, sessionId) => async(dispatch) => {
    dispatch({type: "ITEM_SUBMIT_START"})
    try {
        const {data} = await ItemApi.submitItem(formData, sessionId)
        dispatch({type: "ITEM_SUBMIT_SUCCESS", data: data})
        dispatch({type: "USER_ITEM_INCREMENT", data: data})
    } catch (error) {
        dispatch({type: "ITEM_SUBMIT_FAIL"})
    }
}

export const triggerItem = (userId, datumId, value, triggerType, itemId, triggerID, sessionId) => async(dispatch) => {
    
    dispatch({type: "ITEM_TRIGGER_START"})
    try {
        const {data} = await ItemApi.triggerItem(userId, datumId, value, triggerType, itemId, triggerID, sessionId)
        console.log("Trigger Success? : ", data);
        dispatch({type: "ITEM_TRIGGER_SUCCESS", data: {userId: data.userId, datumId: data.datumId, value: data.data.value ?? null, triggerType: data.data.triggerType ?? null, itemId: data.data.item, triggerId: data.data._id}})
    } catch (error) {
        console.log(error)
        dispatch({type: "ITEM_TRIGGER_FAIL"})
    }
}

export const getItemFeed = (id, filters, page = 0)=> async(dispatch)=> {
    dispatch({type: "ITEM_FEED_START"})
    try {
        const {data} = await ItemApi.getItemFeed(id, filters, page);
        dispatch({type: "ITEM_FEED_SUCCESS", data: data.data, hasMore: data.hasMore, page, totalItems: data.totalItems });
    } catch (error) {
        dispatch({type: "ITEM_FEED_FAIL"})
        console.log(error);
    }
}

// I may eventually want to separate this into its own reducer
// DOne
export const getCategoryFeed = (id, itemId, nav, filters, page = 0) => async (dispatch) => {
    dispatch({ type: "CATEGORY_FEED_START" })
    try {
        const { data } = await ItemApi.getCategoryFeed(id, itemId, filters, page);
        dispatch({ type: "CATEGORY_FEED_SUCCESS", data: data.data, nav, hasMore: data.hasMore, page, totalItems: data.totalItems, isScrollFetch: page > 0 });
        console.log("Dispatch success");
    } catch (error) {
        dispatch({ type: "CATEGORY_FEED_FAIL" })
        console.log(error);
    }
}